export const seoToolsGettingStartedArticle = {
  title: 'SEO Tools Hub: Getting Started',
  slug: 'seo-tools-getting-started',
  content: `SEO Tools Hub: Getting Started

Audit SEO health, review traffic, and connect integrations.

1) Open SEO Tools Hub
- Go to /marketing/seo-tools-hub.
- Tabs use URL hashes (#seo-analyzer, #web-traffic, #keyword-research, #integrations).

2) Run SEO Analyzer
- Use the SEO Analyzer tab for on-page audits.

3) Review web traffic
- Web Traffic tab shows analytics (Google/Bing connections if enabled).

4) Keyword research
- Use Keyword Research for idea discovery.

5) Integrations
- Connect services in the Integrations tab.
`,
};
